import { Button, Grid, GridItem } from "@chakra-ui/react";
import { React, useContext, useState } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { context } from "@/context/valuationContext";

const AmenidadesComunes = ({ onOpen, isGreaterThanMd }) => {
    //Context
    const { addDataCommonAmenities } = useContext(context);
    const [checkedItems, setCheckedItems] = useState([]);

    const amenities = [
        { key: 1, value: "Casa Club" },
        { key: 2, value: "Área Deportiva" },
        { key: 3, value: "Área de Coworking" },
        { key: 4, value: "Alberca" },
        { key: 5, value: "Gym" },
        { key: 6, value: "Elevador" },
        { key: 7, value: "Jacuzzi" },
        { key: 8, value: "Seguridad(vigilancia 24/7)" },
    ];

    const handleCheck = (e) => {
        let items_aux = [...checkedItems];
        if (checkedItems.find((items) => items === Number(e))) {
            items_aux.pop(Number(e));
        } else {
            items_aux.push(Number(e));
        }
        setCheckedItems(items_aux);
    };

    const handleSubmit = () => {
        addDataCommonAmenities(checkedItems);
        onOpen();
    };
    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
            }}
        >
            <Grid templateColumns="repeat(3, 1fr)" gap={4} alignItems="center" mt={2}>
                {amenities.map((amenity, index) => (
                    <GridItem
                        colSpan={isGreaterThanMd ? 1 : 3}
                        textAlign="-webkit-left"
                        key={`amenity-${index}`}
                    >
                        <Checkbox
                            onChange={(e) => handleCheck(e.target.value)}
                            size="lg"
                            value={amenity.key}
                            colorPalette="yellow"
                            color="accent.500"
                        >
                            {amenity.value}
                        </Checkbox>
                    </GridItem>
                ))}
                <GridItem colSpan={3} textAlign="-webkit-right" mt={6}>
                    <Button
                        rounded="full"
                        colorPalette="brand"
                        bg="brand.500"
                        color="black"
                        border="0"
                        px="16"
                        _hover={{ bg: "brand.600" }}
                        type="submit"
                    >
                        Siguiente
                    </Button>
                </GridItem>
            </Grid>
        </form>
    );
};

export default AmenidadesComunes;
